import React from "react";
import { Provider } from "react-redux";
import { EnterpriseDemoRequestMode } from "Services/API/API";
import {
   ContactSection,
   FAQSection,
   PricingSection,
} from "./sections";
import { ContactUsProvider } from "../contexts";

const Pricing: React.FC = () => {
   return (
      <Provider store={LSStore.instance}>
         <ContactUsProvider mode={EnterpriseDemoRequestMode.Pricing}>
            <PricingSection />
            <FAQSection />
            <ContactSection />
         </ContactUsProvider>
      </Provider>
   );
};

export default Pricing;
